
import LazyLoad from "vanilla-lazyload"
import _once from "lodash/once"


const DEFAULT_OPTIONS = {
  selector:                   "img[data-src]",
  source_data_attribute_name: "src",
}


const default_lazyload_instance = _once(() => {
  return new LazyLoad({
    elements_selector:  DEFAULT_OPTIONS.selector,
    data_src:           DEFAULT_OPTIONS.source_data_attribute_name,
    use_native:         true,
  })
})


export default {
  default_lazyload_instance,
}
